import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlogModel } from '../model/blog.model';

@Injectable()
export class BlogService {
  private readonly url = "https://api.1artifactware.com/articles"
  private readonly blogUrl = `${this.url}/type/blog`;
  private readonly blogLoadMoreUrl =  `${this.url}/type/blog/start`;
  constructor(private httpClient: HttpClient) { }

  blog(): Observable<BlogModel> {
    return this.httpClient.get<BlogModel>(this.blogUrl);
  }

  blogLoadMore(start: Number): Observable<BlogModel> {
    return this.httpClient.get<BlogModel>(`${this.blogLoadMoreUrl}/${start}`);
  }
}
